import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ProgressBarModule } from 'primeng/progressbar';

@Component({
  standalone: true,
  selector: 'app-license-limit-banner',
  templateUrl: './license-limit-banner.component.html',
  styleUrls: ['./license-limit-banner.component.scss'],
  imports: [CommonModule, ProgressBarModule, ButtonModule, RouterModule]
})
export class LicenseLimitBannerComponent implements OnInit {
  @Input() licenseLimitUsed: number | undefined;
  @Input() licenseLimitRemaining: number | undefined;
  @Input() licenseLimitModule: string | undefined;

  licencePercentage!: number;

  constructor() {}

  ngOnInit() {
    this.licencePercentage =
      (this.licenseLimitUsed! / (this.licenseLimitRemaining! + this.licenseLimitUsed!)) *
      100;
  }
}
